import styled from 'styled-components';

export const DaiperVarient1OuterDiv = styled.div`
  display: flex;
  column-gap: 10px;
  padding: 0 14px;
  @media (min-width: 720px) {
    padding: 0 2.5%;
    width: 100%;
  }
  .radioLabel {
    cursor: pointer;
    @media (max-width: 720px) {
      cursor: default;
    }
  }
`;
export const DiaperRadioLabel = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  flex-basis: 33%;
  padding: 7px 6px 10px 10px;
  border: solid 1px ${(props) => (props.selected ? '#ef4e5e' : '#ccc')};
  @media (min-width: 720px) {
    flex-direction: row;
    border-radius: 8px;
    cursor: pointer;
    align-items: baseline;
    justify-content: space-between;
    padding: 10px 3% 20px 10px;
  }
  .maintitle {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    padding-bottom: 8px;
    column-gap: 10px;
    border-bottom: solid 0.6px #dadada;
    min-height: ${(props) => (props.varient === 2 ? '60px' : '60px')};
    @media (min-width: 385px) {
      min-height: ${(props) => (props.varient === 2 ? '45px' : '60px')};
    }
    @media (min-width: 490px) {
      min-height: ${(props) => (props.varient === 2 ? '30px' : '45px')};
    }
    @media (min-width: 720px) {
      border: none;
      justify-content: flex-end;
      min-width: 210px;
      align-items: center;
      flex-direction: row-reverse;
    }
    .title {
      flex-basis: 80%;
      @media (min-width: 720px) {
        margin-left: 8px;
      }
    }
    .circle {
      border: 1px solid #ccc;
      width: 14px;
      height: 14px;
      background-color: white;
      border-radius: 50%;
      margin-top: 4px;
      @media (min-width: 720px) {
        margin-top: 0;
        width: 16px;
        height: 16px;
      }
    }
    img {
      height: 16px;
      width: 16px;
      margin-top: 4px;
      @media (min-width: 720px) {
        margin-top: 0;
        width: 18px;
        height: 18px;
      }
    }
  }
  .priceSection {
    font-size: clamp(14px, 2vw, 16px);
    font-weight: 600;
    display: flex;
    align-items: center;
    column-gap: 10%;
    padding-top: 10px;
    span {
      font-size: clamp(12px, 2vw, 14px);
      font-weight: 400;
      text-decoration: line-through;
      color: #999;
    }
  }
  .unitPrice {
    padding: 4px 7px;
    margin-top: 8px;
    border-radius: 2px;
    background-color: #d9eae047;
    font-family: Montserrat;
    font-size: 10px;
    font-weight: 500;
    color: #313942;
    width: fit-content;
  }
`;
